/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Box } from '@atgfr8/atg-ui-tailwind';
import { LastUsedTopStopModel } from '@typeDefinitions/stopTypes';
import { DateTime } from 'luxon';
import { createEffect, createSignal, Show } from 'solid-js';

type PropsT = {
  stop: LastUsedTopStopModel;
  class?: string;
};

export const TimeRangeData = (props: PropsT) => {
  const [beginTime, setBeginTime] = createSignal<DateTime>();
  const [endTime, setEndTime] = createSignal<DateTime>();

  createEffect(() => {
    if (typeof props.stop.beginTimeRange === 'number') {
      const bt = DateTime.fromFormat(
        props.stop.beginTimeRange.toString().padStart(4, '0'),
        'HHmm',
      );
      setBeginTime(bt);
    } else {
      setBeginTime(undefined);
    }

    if (typeof props.stop.endTimeRange === 'number') {
      const et = DateTime.fromFormat(
        props.stop.endTimeRange.toString().padStart(4, '0'),
        'HHmm',
      );
      setEndTime(et);
    } else {
      setEndTime(undefined);
    }
  });

  return (
    <Box class={props.class}>
      <Box>
        <Show when={beginTime()?.isValid}>
          <span>
            {beginTime()?.toFormat('HH:mm')}{' '}
            <Show when={endTime()?.isValid}>
              - {endTime()?.toFormat('HH:mm')}&nbsp;
            </Show>
          </span>
        </Show>
        <span>{props.stop.timeComments}</span>
      </Box>
    </Box>
  );
};
